import api from '../../redux/api';
import { SELLER_BASE } from './constants';

export const sellerAnalyticsService = {
  getDashboardKPIs: async (params = {}) => {
    const response = await api.get('/analytics/seller/dashboard/kpis', { params });
    return response.data;
  },

  getDashboardStats: async (params = {}) => {
    const response = await api.get(`${SELLER_BASE}/analytics/dashboard`, { params });
    return response.data;
  },

  getSalesReport: async (params = {}) => {
    const response = await api.get(`${SELLER_BASE}/analytics/sales`, { params });
    return response.data;
  },

  getCustomerAnalytics: async (params = {}) => {
    const response = await api.get(`${SELLER_BASE}/analytics/customers`, { params });
    return response.data;
  },

  getProductPerformance: async (params = {}) => {
    const response = await api.get(`${SELLER_BASE}/analytics/products`, { params });
    return response.data;
  },

  exportReport: async (reportType, params = {}) => {
    const response = await api.get(`${SELLER_BASE}/analytics/export/${reportType}`, {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  getTopTransactions: async (params = {}) => {
    const response = await api.get(`${SELLER_BASE}/analytics/top-transactions`, { params });
    return response.data;
  },
};

export default sellerAnalyticsService;
